<template>
  <div class="page page-product">
    <PagesProductHero :pretitle="page?.productPretitle" :title="page?.name" :description="page?.productDescription" :media="page?.productMedia" />

    <!-- Product Main -->
    <section v-if="page?.grid">
      <PagesProductGrid :data="page.grid" /> 
    </section>
    
    <!-- Next Product -->
    <section v-if="nexProduct">
      <PagesProductNextProduct :product="nexProduct" />
    </section>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'
import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()
const route = useRoute()

const touch = ref(false)

const query = queries.product.getProduct
const variables = computed(() => ({
  locale: locale.value,
  slug: route.params.slug,
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.product) {
  throw createError({ statusCode: 404 })
}

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const page = computed(() => data?.value?.product)
const nexProduct = computed(() => {
  const actualProductIndex = data.value?.allProducts?.findIndex(
    (product) => product.slug === route.params.slug,
  )
  const nextIndex =
    actualProductIndex + 1 >= data.value.allProducts.length
      ? 0
      : actualProductIndex + 1
  const nextProductObj = data.value.allProducts[nextIndex]
  return nextProductObj && actualProductIndex !== nextIndex ? nextProductObj : null
})

const seo = computed(() => data?.value?.product?.seo || {})

// Seo
useSeo({
  ...seo.value,
})
</script>
